export const KEYCODES = {
  up: 38,
  down: 40,
  enter: 13,
  esc: 27,
  space: 32,
  tab: 9
}
